import Grid from '@mui/material/Grid';
import Carousel from './Carousel';

const CaseItem = ({ caseEl}) => {
    return (
        caseEl.systems.length>0?
    <Grid container sx={{marginBottom:"25px",marginTop:"25px"}}>
        <Grid item xs={12} md={10}>
            <Carousel sources={caseEl.systems} slidestyle={{textAlign:"center"}} autoplay navigation/>
        </Grid>
    </Grid>:null)
}

export default CaseItem;